import React from "react";

import { Avatar, Badge, HStack, Text, TextProps } from "@chakra-ui/react";

import { User } from "@/jenesys-types/jenesys-entities/config";

interface MentionBadgeProps {
  user: User;
  size?: TextProps["fontSize"];
}

export const MentionBadge: React.FC<MentionBadgeProps> = ({
  user,
  size = "md"
}) => {
  const getSizeProps = () => {
    switch (size) {
      case "xs":
        return { px: 1, py: 0.5, fontSize: "2xs" };
      case "sm":
        return { px: 2, py: 0.5, fontSize: "xs" };
      case "lg":
        return { px: 3, py: 1, fontSize: "md" };
      default:
        return { px: 2.5, py: 0.5, fontSize: "sm" };
    }
  };

  const getAvatarSize = () => {
    switch (size) {
      case "xs":
        return "2xs";
      case "sm":
        return "xs";
      case "lg":
        return "sm";
      default:
        return "xs";
    }
  };

  return (
    <Badge
      colorScheme="blue"
      variant="subtle"
      borderRadius="full"
      fontWeight="medium"
      {...getSizeProps()}
    >
      <HStack spacing={1}>
        <Avatar
          size={getAvatarSize()}
          name={`${user.first_name} ${user.last_name}`}
        />
        <Text>
          {user.first_name} {user.last_name}
        </Text>
      </HStack>
    </Badge>
  );
};
